import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { InputRadioProps } from './input-radio.type';

export const InputRadio = forwardRef(
  (
    {
      id,
      name,
      disabled,
      label,
      secondaryLabel,
      description,
      strikeThrough,
      checked,
      containerClassName,
      inputContainerClassName,
      value,
      onChange,
      ...props
    }: InputRadioProps,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <label
        className={classNames('flex flex-col transition', containerClassName, {
          'cursor-pointer': !disabled,
          'border-extra-soft': !checked,
        })}>
        <div
          className={classNames('text-subtitle-s flex items-center', inputContainerClassName, {
            'text-primary': !!checked && !disabled,
            'text-secondary': !checked && !disabled,
            'text-tertiary': !!disabled,
            'line-through': !!disabled && !!strikeThrough,
          })}>
          <input
            ref={ref}
            {...props}
            id={id}
            name={name}
            disabled={disabled}
            type='radio'
            className={classNames('mr-3 h-5 w-5 shrink-0 rounded-full', 'focus:outline-hidden focus:ring-0')}
            value={value}
            checked={checked}
            onChange={onChange}
          />
          <span className='mt-0.5 w-full'>{label}</span>
        </div>
        {(secondaryLabel || description) && (
          <div className='ml-8 flex flex-col gap-1.5'>
            {secondaryLabel && <span className='text-tertiary text-body-s'>{secondaryLabel}</span>}
            {description && <div className='w-full'>{description}</div>}
          </div>
        )}
      </label>
    );
  }
);
